import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LegendSwatchStyled } from "./area-polygons-legend.styled";
import { IAreaPolygonItem } from "./area-polygons-map.models";

interface IAreaPolygonsLegendItemProps {
  area: IAreaPolygonItem;
  isHidden: boolean;
  // When this area is being reshaped in-map, its hide control is locked.
  isEditing?: boolean;
  onToggle?: (id: number) => void;
  onEditArea?: (id: number) => void;
}

export const AreaPolygonsLegendItem: FC<IAreaPolygonsLegendItemProps> = ({
  area: { id, name, color, polygon },
  isHidden,
  isEditing,
  onToggle,
  onEditArea,
}) => {
  const { t } = useTranslation();
  const hasPolygon = Boolean(polygon?.features?.length);
  const hoverTitle = `${name} (#${id})`;
  const toggleTitle = isEditing
    ? t("area.mapEditShapeLockedSelection")
    : t("area.mapToggleAreaVisibility");

  return (
    <div
      className={clsx(
        "legend-item",
        isHidden && "is-hidden",
        !hasPolygon && "is-empty",
        isEditing && "is-editing",
      )}
    >
      {hasPolygon ? (
        <LegendSwatchStyled
          type="button"
          $color={color}
          $isHidden={isHidden}
          onClick={() => onToggle?.(id)}
          disabled={isEditing}
          aria-pressed={!isHidden}
          aria-label={toggleTitle}
          title={toggleTitle}
        />
      ) : (
        <LegendSwatchStyled
          as="span"
          $isEmpty
          title={t("area.mapNoPolygonTag")}
        />
      )}
      {onEditArea ? (
        <button
          type="button"
          className="legend-name legend-name--clickable"
          onClick={() => onEditArea(id)}
          title={hoverTitle}
        >
          {name}
        </button>
      ) : (
        <span className="legend-name" title={hoverTitle}>
          {name}
        </span>
      )}
      {!hasPolygon && (
        <span className="legend-empty-tag">{t("area.mapNoPolygonTag")}</span>
      )}
    </div>
  );
};
